// extracted by mini-css-extract-plugin
export var discard = "_23-4";
export var muiTooltipTooltip = "_23-6";
export var notificationBar = "_23-3";
export var notificationContainer = "_23-2";
export var saveButtonHoverSlotWrapper = "_23-5";
export var show = "_23-1";
export var spacer = "_23-0";